import React from 'react';
import { HeaderView as DesktopHeaderView } from 'app/views/components/header/platform/Desktop';
import { HeaderView as MobileHeaderView } from 'app/views/components/header/platform/Mobile';
import { Capabilities } from 'app/utils/Capabilities';
export function HeaderView() {
    const Header = Capabilities.shared.isMobileDevice
        ? MobileHeaderView
        : DesktopHeaderView;
    return React.createElement(Header, null);
}
